<div class="position-relative">
  <div class="parent-tag-container" #parentContainer></div>
  <div
  *ngIf="this.showPlaceHolder"
    class="text-truncate parent-tag-container-copy position-absolute {{ this.showPlaceHolder ? '' : 'd-none' }}">
    {{ title }}</div>
</div>
